import { useCallback } from "react";
import {
  Alert,
  Button,
  Group,
  Loader,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useCommunicationRedirectSettings } from "../../../hooks/admin/useCommunicationRedirectSettings";
import RedirectBypassPrefixEditor from "./RedirectBypassPrefixEditor";

interface RedirectBypassPrefixModalProps {
  opened: boolean;
  onClose: () => void;
}

export default function RedirectBypassPrefixModal({
  opened,
  onClose,
}: RedirectBypassPrefixModalProps) {
  const settingsQuery = useCommunicationRedirectSettings(opened);
  const handleRetry = useCallback(() => {
    settingsQuery.refetch();
  }, [settingsQuery]);

  if (settingsQuery.data) {
    return (
      <RedirectBypassPrefixEditor
        key={settingsQuery.data.revision}
        opened={opened}
        settings={settingsQuery.data}
        onClose={onClose}
        onReload={handleRetry}
      />
    );
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Redirect bypass prefixes"
      size="lg"
      centered
    >
      {settingsQuery.isError ? (
        <Alert
          icon={<IconAlertTriangle size={18} />}
          color="red"
          variant="light"
          title="Could not load redirect settings"
          role="alert"
        >
          <Stack gap="sm">
            <Text size="sm">{settingsQuery.error.message}</Text>
            <Button color="red" variant="light" size="xs" onClick={handleRetry}>
              Retry
            </Button>
          </Stack>
        </Alert>
      ) : (
        <Group justify="center" py="xl" gap="sm">
          <Loader size="sm" />
          <Text size="sm">Loading prefix settings…</Text>
        </Group>
      )}
    </Modal>
  );
}
